export default "__VITE_ASSET__c342e048__"